import _typeof from 'babel-runtime/helpers/typeof';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import PropTypes from '../_util/vue-types';
import { RecycleScroller } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

var SubPopupMenuChildrenWrapper = {
  name: 'SubPopupMenuChildrenWrapper',
  props: {
    children: PropTypes.any.def([]),
    renderMenuItem: PropTypes.func,
    eventKey: PropTypes.string,
    virtual: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
  },
  render: function render() {
    var h = arguments[0];

    var props = _objectWithoutProperties(this.$props, []);

    var children = props.children,
        renderMenuItem = props.renderMenuItem,
        eventKey = props.eventKey,
        virtual = props.virtual;


    var itemSize = 32;
    if ((typeof virtual === 'undefined' ? 'undefined' : _typeof(virtual)) === 'object' && 'itemSize' in virtual) {
      itemSize = virtual.itemSize;
    }

    return h(
      RecycleScroller,
      {
        style: 'max-height: inherit',
        attrs: { items: children,
          'item-size': itemSize,
          'key-field': 'key'
        }
      },
      [function (_ref) {
        var item = _ref.item,
            index = _ref.index;

        return renderMenuItem(item, index, eventKey || '0-menu-');
      }]
    );
  }
};

export default SubPopupMenuChildrenWrapper;